import GroupScreen from '../../components/layout/group-screen';
import { JOB_NAMES } from '../../constants/jobNames';
import UnitsList from './units-list';
import UnitTypesList from '../unit-types/unit-type-list';
import UnitVillagesList from '../unit-villages/unit-villages-list';

/** Units — merged screen for the unit family (master, types, villages). */
const UnitsGroup = () => (
  <GroupScreen
    icon="pi pi-building"
    iconBgColor="bg-blue-600"
    title="Units"
    subtitle="Unit master, unit types and unit villages"
    testId="SCR-UnitsGroup"
    tabs={[
      { key: 'units', header: 'Unit Master', leftIcon: 'pi pi-building', jobs: [JOB_NAMES.UNITS], element: <UnitsList embedded /> },
      { key: 'unit-types', header: 'Unit Types', leftIcon: 'pi pi-tags', jobs: [JOB_NAMES.UNIT_TYPE], element: <UnitTypesList embedded /> },
      { key: 'unit-villages', header: 'Unit Villages', leftIcon: 'pi pi-map-marker', jobs: [JOB_NAMES.UNIT_VILLAGES], element: <UnitVillagesList embedded /> },
    ]}
  />
);

export default UnitsGroup;
